module.exports = __webpack_public_path__ + "src/assets/img/m28.b52ee8cf.svg";